import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const bigroadConfig: TSPConfig = {
  key: 'bigroad',
  name: 'BigRoad',
  category: TSPCategory.API_KEY,
  helpText: (
    <>
      <p>
        Follow the instructions{' '}
        <a
          href='https://app.bigroad.com/manage-api-key'
          target='_blank'
          rel='noreferrer'
        >
          here
        </a>{' '}
        to generate a new API key. Then, input that key here.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default bigroadConfig;
